import { getGraphqlClient } from "@/api/graphql/client.ts";

import { deleteFormDataRuleGroupMutation } from "./mutations.ts";

export const deleteFormDataRuleGroup = (id: string) => {
  const graphqlClient = getGraphqlClient();

  return graphqlClient.request(deleteFormDataRuleGroupMutation, { id });
};
